module.exports = "/_next/static/images/headphonesalt-e6b4686a184646a9fd52ac79cf4cd5a3.svg";